$shm_dotsloader $mol_view
	attr *
		^ title \Загрузка
	sub /
		<= Dot_first $mol_view
		<= Dot_second $mol_view
		<= Dot_third $mol_view
